import React from 'react';
import PropTypes from 'prop-types';
import { Document, Page } from 'react-pdf/dist/entry.noworker';

// Security (ACS-256 / CVE-2024-4367): pdf.js 2.0.305 builds font glyph outlines
// as JavaScript source and compiles them with `new Function`. A crafted PDF can
// put script in its /FontMatrix and have it run in this page's origin when the
// file is previewed. With isEvalSupported off, pdf.js draws the same glyphs with
// its built-in interpreter and never compiles anything taken from the PDF.
// react-pdf 3.x's setOptions() ignores this key, so set it on the shared pdf.js
// global. pdf.js reads that global each time it loads a font and keeps any value
// already there when it initialises.
// Remove after react-pdf is upgraded to a version that ships pdfjs-dist >= 4.2.67.
const pdfjsGlobalSettings = window.PDFJS || (window.PDFJS = {});
pdfjsGlobalSettings.isEvalSupported = false;

export class FilePreviewer extends React.Component {
  constructor() {
    super();
    this.state = {
      numPages: 1
    };
  }

  onLoadSuccess({numPages}) {
    this.setState({numPages});
  }

  renderPreview() {
    let fileType = this.props.file.type;

    if (fileType.includes('image')) {
      return(
        <div className="file-previewer__preview">
          <img className="file-previewer__preview-image"
            src={this.props.file.preview}
            alt={this.props.file.name}
            title={this.props.file.name}/>
        </div>
      );
    } else if(fileType === "application/pdf") {
      return(
        <div className="file-previewer__preview">
          <Document
            className="file-previewer__preview-pdf"
            file={this.props.file.preview}
            onLoadSuccess={this.onLoadSuccess.bind(this)}
          >
          { this.props.renderAllPages ?
              Array.from(
                new Array(this.state.numPages),
                (el, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    renderTextLayer={false}
                  />
                ),
              )
              :
              <Page
                pageNumber={1}
                renderTextLayer={false}
              />
          }
          </Document>
        </div>
      );
    } else {
      return(
        <div className="file-previewer__preview">
          <span className="file-previewer__preview-none">
            NO PREVIEW AVAILABLE
          </span>
        </div>
      );
    }
  }

  render(renderAllPages=false) {
    return(
      <div className="file-previewer">
        {this.renderPreview(renderAllPages)}
      </div>
    );
  }
}

FilePreviewer.propTypes = {
  file: PropTypes.object,
  renderAllPages: PropTypes.bool
};

export default FilePreviewer;
